import styled, { css } from 'styled-components';
import { theme } from '../../../styles/theme';
import { IconName, SvgIcon } from '../../Icon';
import KubitTooltip from '../../KubitTooltip';
import { ITooltipOption } from '../../KubitTooltip/globalTooltips';

interface IProps extends ITooltipOption {
  iconName: IconName;
  onClick: () => void;
  isActive: boolean;
}

const StyledIcon = styled(SvgIcon)<{ $isActive: boolean }>`
  &:hover {
    cursor: pointer;
    fill: ${theme.colors.secondary800};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      border-radius: 2px;
      background-color: ${theme.colors.blue500};
      fill: ${theme.colors.secondary800};
    `}
`;

const ChartViewControllerItem = ({
  iconName,
  onClick,
  isActive,
  ...tooltipOption
}: IProps) => (
  <KubitTooltip {...tooltipOption} noOpenDelay={true} placement="top">
    <StyledIcon
      name={iconName}
      width={24}
      height={24}
      onClick={onClick}
      $isActive={isActive}
    />
  </KubitTooltip>
);

export default ChartViewControllerItem;
